var ArchivedProjects, FullProjects, OrderedCollection, Project, Set, User, W, mediator, sequence,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

OrderedCollection = require('models/base/ordered_collection');

Project = require('models/project');

FullProjects = require('models/full_projects');

User = require('models/user');

Set = require('base/lib/set');

sequence = require('when/sequence');

mediator = require('mediator');

W = require('when');

module.exports = ArchivedProjects = (function(_super) {
  __extends(ArchivedProjects, _super);

  function ArchivedProjects() {
    return ArchivedProjects.__super__.constructor.apply(this, arguments);
  }

  ArchivedProjects.prototype.model = Project;

  ArchivedProjects.prototype._redirects = {};

  ArchivedProjects.prototype.setOrderOnAdd = false;

  ArchivedProjects.prototype.fetch = function() {
    var projectDBs;
    projectDBs = mediator.user.getProjectsFromTrash();
    return this._getProjectsData(projectDBs).then((function(_this) {
      return function(map) {
        _this.additionalProjectsData = map;
        return _this._fetchProjects(projectDBs);
      };
    })(this));
  };

  return ArchivedProjects;

})(FullProjects);
